export default "__VITE_ASSET__385e35ba__"